var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.973,
    height: 29.249,
    viewBox: "0 0 31.973 29.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cloud-computing",
    transform: "translate(0 -21.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M25.1,29.8A9.986,9.986,0,0,0,5.332,31.766c0,.225.009.455.029.7A5.991,5.991,0,0,0,6,44.414h.7c-.016-.221-.033-.441-.033-.666a8.654,8.654,0,1,1,17.309,0c0,.225-.017.445-.033.666h.7A7.315,7.315,0,0,0,25.1,29.8Z",
    transform: "translate(0 0)",
    fill: "#b4b4b4"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 7.323,
    cy: 7.323,
    r: 7.323,
    transform: "translate(7.995 36.426)",
    fill: "#27a7df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14",
    transform: "translate(11.998 39.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M235.433,307.789a.666.666,0,0,1-.666-.666v-7.989a.666.666,0,0,1,1.331,0v7.989A.666.666,0,0,1,235.433,307.789Z",
    transform: "translate(-232.113 -298.469)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M198.223,302.476a.666.666,0,0,1-.471-.194l-2.192-2.193-2.192,2.193a.666.666,0,0,1-.941-.941l2.663-2.663a.666.666,0,0,1,.941,0l2.663,2.663a.666.666,0,0,1-.471,1.136Z",
    transform: "translate(-192.24 -298.481)",
    fill: "#fafafa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.9afdb75d6856d8aa9318d223e51f2786.svg";
export { ForwardRef as ReactComponent };